import { render } from "./long-text-template.vue?vue&type=template&id=de55ee0c"
import script from "./long-text-template.vue?vue&type=script&setup=true&lang=js"
export * from "./long-text-template.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cell-template-components/long-text-template.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de55ee0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de55ee0c', __exports__)) {
    api.reload('de55ee0c', __exports__)
  }
  
  module.hot.accept("./long-text-template.vue?vue&type=template&id=de55ee0c", () => {
    api.rerender('de55ee0c', render)
  })

}


export default __exports__